import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SESSION } from '../config/session';

// Landing page after a verified payment.
//
// Payment.js has always navigated here on success, but no route and no page
// existed, and App.js had no catch-all — so React Router matched nothing and
// rendered a blank white page at the single worst moment in the flow, right
// after the applicant's money had been taken. The payment itself was recorded
// correctly server-side; only this page was missing.
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { paymentId, applicationId, applicationNumber } = location.state || {};

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="mt-4 text-xl font-semibold text-gray-900">Payment Successful</h2>
          <p className="mt-2 text-gray-600">
            Your application fee has been received and your application is confirmed.
          </p>
        </div>

        {(applicationNumber || paymentId) && (
          <div className="mt-6 bg-gray-50 border border-gray-200 rounded-md p-4 space-y-2">
            {applicationNumber && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Application Number</span>
                <span className="font-semibold text-gray-900">{applicationNumber}</span>
              </div>
            )}
            {paymentId && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Payment Reference</span>
                <span className="font-mono text-xs text-gray-900 break-all">{paymentId}</span>
              </div>
            )}
          </div>
        )}

        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-md p-4">
          <h3 className="text-sm font-medium text-blue-800">What happens next</h3>
          <ul className="mt-2 text-sm text-blue-700 list-disc list-inside space-y-1">
            <li>Admit cards are issued from <strong>{SESSION.admitCards.availableFromLabel}</strong></li>
            <li>
              The entrance test is on <strong>{SESSION.exam.dateLabel}</strong>, {SESSION.exam.time},
              at {SESSION.exam.centre}
            </li>
            <li>Keep your application number for all future correspondence</li>
          </ul>
        </div>

        <div className="mt-6 space-y-3">
          {applicationId && (
            <button
              onClick={() => navigate(`/admit-card/${applicationId}`)}
              className="w-full bg-green-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-green-700 transition-colors"
            >
              View Admit Card
            </button>
          )}
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gray-100 text-gray-800 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
